import { createAction } from '@reduxjs/toolkit';
export const SOCKET_DISCONNECT = 'SOCKET_DISCONNECT';
export const socketDisconnectAction = createAction(SOCKET_DISCONNECT);